import * as api from "services/api";

export const GET_INVENTORY = "[PRODUCT REPORT] GET_INVENTORY";
export const CLEAR_ITEMS = "[PRODUCT REPORT] CLEAR_ITEMS";
export const GET_INVENTORY_FAILED = "[PRODUCT REPORT] GET_INVENTORY_FAILED";
export const GET_INVENTORY_SUCCESS = "[PRODUCT REPORT] GET_INVENTORY_SUCCESS";
export const SET_SEARCH_TEXT = "[PRODUCT REPORT] SET_SEARCH_TEXT";
export const SET_VALUE = "[INVENTORY REPORT] SET_VALUE";

export function getInventory() {
  return async (dispatch, getState) => {
    dispatch({
      type: GET_INVENTORY
    });

    const { token } = getState().login;

    let response = await api.sendGet("/product/item/inventory", {
      Authorization: "Bearer " + token
    });

    if (response.ok) {
      let json = await response.json();

      let payload = json.model;
      dispatch({
        type: GET_INVENTORY_SUCCESS,
        payload
      });
    } else {
      dispatch({ type: GET_INVENTORY_FAILED });
    }
  };
}

export function clearItems() {
  return {
    type: CLEAR_ITEMS
  };
}

export function getInventoryV2(
	skip,
	take,
	filter,
	sort,
	desc,
	toExport,
	callback
) {
	return async (dispatch, getState) => {
		dispatch({
			type: GET_INVENTORY
		});

		const { login } = getState();
		const { token } = login;

		let response = await api.sendGet(
			`/product/item/Inventory/v2?skip=${skip}&take=${take}&sort=${sort}&desc=${desc}${filter || ""}`,
			{
				Authorization: "Bearer " + token
			}
		);

		if (response.ok) {
			let result = await response.json();

			if (result.isValid) {
				if (toExport) {
					dispatch(setValue({ loading: false }));
				} else {
					dispatch({
						type: GET_INVENTORY_SUCCESS,
						payload: result.model
					});

					if (result.params)
						dispatch(
							setValue({
								pages: Math.ceil(result.params.count / take),
								...result.params
							})
						);
				}

				callback && callback(null, result.model);
			} else {
				dispatch({ type: GET_INVENTORY_FAILED, payload: result.errors });
				callback && callback(result.errors, result.model);
			}
		} else {
			dispatch({ type: GET_INVENTORY_FAILED });
			callback && callback("Ocorreu um erro ao tentar carregar o inventário");
		}
	};
}

export function setValue(payload) {
	return {
		type: SET_VALUE,
		payload
	};
}

export function getProductItemWithInventories(itemId, callback) {
	return async (dispatch, getState) => {
		const { login } = getState();
		const { token } = login;

		let response = await api.sendGet(
			`/product/item/Inventory/v2?skip=0&take=1&includeAllInventories=true&filters[id]=${itemId}`,
			{
				Authorization: "Bearer " + token
			}
		);

		if (response.ok) {
			let result = await response.json();

			if (result.isValid && result.model && result.model.length > 0) {
				callback && callback(null, result.model[0]);
			} else {
				callback && callback("Item não encontrado", null);
			}
		} else {
			callback && callback("Ocorreu um erro ao tentar carregar o inventário", null);
		}
	};
}
